// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"a8952df1","239":"50f5cbf3","389":"9756a75d","407":"c0e59c8f","453":"8eb871ff","455":"270a58d2","529":"25969105","608":"f9c0cc90","977":"d88b8917"}[chunkId] + ".chunk.js";
};